export var searchParametersToSegmentsAdapter = function (searchParams) {
    return searchParams.map(function (searchParam, index) { return ({
        id: index.toString(10),
        title: "".concat(searchParam.departure.iata, "-").concat(searchParam.arrival.iata),
        isDisabled: false
    }); });
};
